import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import Button from '../helpers/Button';
import FormGroup from '../helpers/FormGroup';
import { InputProps } from '../helpers/AutoComplete';

const ActiveTargetPopup = props => {
  const {
    isFinancialBuyer,
    buyerName,
    suggestDirector,
    suggestAnalyst,
    processing,
    message,
    onClose,
    onCreate,
  } = props;

  if (isFinancialBuyer) {
    const header = (
      <span className="text-danger">
        <i className="fa fa-exclamation-triangle" /> Can&quot;t activate Target role for this company
      </span>
    );
    const footer = (
      <Button onClick={onClose} autoFocus>
        Close
      </Button>
    );

    return (
      <Popup footer={footer} header={header} id="isFinancialBuyer">
        <p>Financial buyers (PEGs/LBOs/VCs) can&quot;t be approached as target companies.</p>
      </Popup>
    );
  }

  const footer = (
    <>
      <Button key="create" className="btn-primary" disabled={processing} onClick={onCreate}>
        Create
      </Button>
      <Button key="close" disabled={processing} onClick={onClose} autoFocus>
        Close
      </Button>
    </>
  );
  const alert = message ? <p className="text-danger">{message}</p> : null;

  return (
    <Popup footer={footer} header="Activate Target role for this company" id="isAddingTargetPopup" loading={processing}>
      <p>Active the "Target" role for "{buyerName}", marking it as an approachable target company?</p>
      <div className="row">
        <FormGroup className="col-xs-6">
          <InputProps className="form-control input-sm" label="Module" name="suggestDirector" placeholder="Module">
            {suggestDirector}
          </InputProps>
        </FormGroup>
        <FormGroup className="col-xs-6">
          <InputProps
            className="form-control input-sm"
            label="Analyst/Associate"
            name="suggestAnalyst"
            placeholder="Analyst/Associate"
          >
            {suggestAnalyst}
          </InputProps>
        </FormGroup>
      </div>
      {alert}
    </Popup>
  );
};

export default memo(ActiveTargetPopup);
